export default __webpack_public_path__ + "static/media/T3_350x500.260e70e5.png";